module.exports = "<td ng-class=\"'content-align-' + column.alignContent\">\n  <div ng-if=\"column.allowHTML\" ng-bind-html=\"sanitize(column.formatFunction(value))\"></div>\n  <div ng-if=\"!column.allowHTML\" ng-bind=\"column.formatFunction(value)\"></div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/dynamic-table/default-cell/template.html
// module id = 417
// module chunks = 1